import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import LogsDashboard from './pages/LogsDashboard';
const Logs = () => {
    const [searchPanelOpen, setSearchPanelOpen] = useState(false);

    return (
        <div className="container-fluid">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <h1>
                    <i className="bi bi-journal-text"></i> Scheduler Logs
                </h1>
            </div>

            <Card className="logs-card shadow-sm border-0">
                <Card.Body className="p-3">
                    <LogsDashboard
                        searchPanelOpen={searchPanelOpen}
                        onSearchPanelToggle={() => setSearchPanelOpen((open) => !open)}
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default Logs;
